import { PostData } from "../../../services/FetchData";

const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const validateBannerImageFile = (file) => {
	if (!file) return null;
	if (!ALLOWED_IMAGE_TYPES.includes((file.type || "").toLowerCase())) {
		return "Invalid file type. Allowed: JPG, PNG, GIF, WEBP.";
	}
	if (file.size > MAX_FILE_SIZE_BYTES) {
		return "File too large. Maximum size is 5 MB.";
	}
	return null;
};

export const uploadBannerImageToSbend = async (websiteId, file) => {
	const validationError = validateBannerImageFile(file);
	if (validationError) {
		return { status: "failure", message: validationError };
	}

	const formData = new FormData();
	formData.append("websiteId", String(websiteId));
	formData.append("file", file);

	const response = await PostData(
		"ms1",
		"api/v1/merchandising/uploadBannerImage",
		formData,
		true
	);

	if (response !== "Invalid" && response !== "undefined" && response?.status === "success") {
		return {
			status: "success",
			fileUrl: response?.data?.fileUrl || response?.fileUrl,
			message: response?.message,
		};
	}

	return {
		status: "failure",
		message:
			response?.message?.message ||
			response?.message ||
			"Failed to upload banner image",
	};
};

export const isValidImageUrl = (url) =>
	/^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(url || "");
